/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlFileMetadata } from './ControlFileMetadata';
import {
    ControlFileMetadataFromJSON,
    ControlFileMetadataFromJSONTyped,
    ControlFileMetadataToJSON,
} from './ControlFileMetadata';
import type { ControlFileRisk1 } from './ControlFileRisk1';
import {
    ControlFileRisk1FromJSON,
    ControlFileRisk1FromJSONTyped,
    ControlFileRisk1ToJSON,
} from './ControlFileRisk1';

/**
 * 
 * @export
 * @interface ControlFile
 */
export interface ControlFile {
    /**
     * 
     * @type {boolean}
     * @memberof ControlFile
     */
    contained?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlFile
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ControlFile
     */
    displayName: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlFile
     */
    enrichedViaIntegration: boolean;
    /**
     * 
     * @type {ControlFileRisk1}
     * @memberof ControlFile
     */
    fileRisk: ControlFileRisk1;
    /**
     * 
     * @type {string}
     * @memberof ControlFile
     */
    id: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlFile
     */
    lastEnrichedAt?: { [key: string]: any; };
    /**
     * 
     * @type {ControlFileMetadata}
     * @memberof ControlFile
     */
    metadata?: ControlFileMetadata;
    /**
     * 
     * @type {string}
     * @memberof ControlFile
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlFile
     */
    nameWithPath?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlFile
     */
    path?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlFile
     */
    sha1?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlFile
     */
    sha256?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlFile
     */
    teamId: string;
    /**
     * 
     * @type {string}
     * @memberof ControlFile
     */
    toolName?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlFile
     */
    updatedAt: string;
}

/**
 * Check if a given object implements the ControlFile interface.
 */
export function instanceOfControlFile(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "displayName" in value;
    isInstance = isInstance && "enrichedViaIntegration" in value;
    isInstance = isInstance && "fileRisk" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "teamId" in value;
    isInstance = isInstance && "updatedAt" in value;

    return isInstance;
}

export function ControlFileFromJSON(json: any): ControlFile {
    return ControlFileFromJSONTyped(json, false);
}

export function ControlFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlFile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contained': !exists(json, 'contained') ? undefined : json['contained'],
        'createdAt': json['createdAt'],
        'displayName': json['displayName'],
        'enrichedViaIntegration': json['enrichedViaIntegration'],
        'fileRisk': ControlFileRisk1FromJSON(json['fileRisk']),
        'id': json['id'],
        'lastEnrichedAt': !exists(json, 'lastEnrichedAt') ? undefined : json['lastEnrichedAt'],
        'metadata': !exists(json, 'metadata') ? undefined : ControlFileMetadataFromJSON(json['metadata']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'nameWithPath': !exists(json, 'nameWithPath') ? undefined : json['nameWithPath'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'sha1': !exists(json, 'sha1') ? undefined : json['sha1'],
        'sha256': !exists(json, 'sha256') ? undefined : json['sha256'],
        'teamId': json['teamId'],
        'toolName': !exists(json, 'toolName') ? undefined : json['toolName'],
        'updatedAt': json['updatedAt'],
    };
}

export function ControlFileToJSON(value?: ControlFile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contained': value.contained,
        'createdAt': value.createdAt,
        'displayName': value.displayName,
        'enrichedViaIntegration': value.enrichedViaIntegration,
        'fileRisk': ControlFileRisk1ToJSON(value.fileRisk),
        'id': value.id,
        'lastEnrichedAt': value.lastEnrichedAt,
        'metadata': ControlFileMetadataToJSON(value.metadata),
        'name': value.name,
        'nameWithPath': value.nameWithPath,
        'path': value.path,
        'sha1': value.sha1,
        'sha256': value.sha256,
        'teamId': value.teamId,
        'toolName': value.toolName,
        'updatedAt': value.updatedAt,
    };
}

